import { useContext } from 'react';

import { HeaderPropsContext } from './HeaderPropsContext';

export interface UseHeaderProps {
  supportedOpCos?: string[];
}

export const useHeaderProps = () => {
  const headerProps = useContext(HeaderPropsContext);

  if (headerProps === undefined) {
    throw new Error('Expected to have a configured HeaderPropsProvider but none found');
  }

  return headerProps;
};
